var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgFacebook(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 23 46' }, props),
        React.createElement("path", { fillRule: 'evenodd', d: 'M18.8 7.638H23V.324C22.276.224 19.784 0 16.883 0 10.828 0 6.68 3.808 6.68 10.808v6.442H0v8.177h6.68V46h8.192V25.428h6.41l1.018-8.176h-7.43v-5.633c.002-2.363.638-3.981 3.93-3.981z' })));
}
export default SvgFacebook;
//# sourceMappingURL=Facebook.js.map